import React from 'react';
import { Select } from '../atoms/Select';
import { Input } from '../atoms/Input';
import { SquadFilter, SquadFilterValue } from './SquadFilter';

interface FilterBarProps {
  brandFilter: string;
  onBrandFilterChange: (value: string) => void;
  availableBrands: string[];
  searchQuery: string;
  onSearchQueryChange: (value: string) => void;
  squadFilter: SquadFilterValue;
  onSquadFilterChange: (value: SquadFilterValue) => void;
}

export const FilterBar: React.FC<FilterBarProps> = ({
  brandFilter,
  onBrandFilterChange,
  availableBrands,
  searchQuery,
  onSearchQueryChange,
  squadFilter,
  onSquadFilterChange,
}) => {
  const brandOptions = [
    { value: 'all', label: 'Todas as marcas' },
    ...availableBrands.map((brand) => ({ value: brand, label: brand })),
  ];

  return (
    <div className="flex flex-col lg:flex-row gap-4 lg:items-end">
      <div className="flex-1">
        <label className="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-2">
          Pesquisar
        </label>
        <Input
          type="text"
          placeholder="Buscar por título..."
          value={searchQuery}
          onChange={(e) => onSearchQueryChange(e.target.value)}
          icon={
            <svg
              className="w-5 h-5"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          }
        />
      </div>
      <div className="flex-shrink-0">
        <label className="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-2">
          Squads
        </label>
        <SquadFilter value={squadFilter} onChange={onSquadFilterChange} />
      </div>
      <div className="w-full lg:w-64">
        <label className="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-2">
          Marcas
        </label>
        <Select
          options={brandOptions}
          value={brandFilter}
          onChange={(e) => onBrandFilterChange(e.target.value)}
        />
      </div>
    </div>
  );
};
